export default __webpack_public_path__ + "static/AntiqueOliveStd-Nord-ad791de17cee1c90579fd85125cae013.ttf";